module.exports = {
	"articleTitle1": "Regents approve $4.3 million Bursley renovations ",
	"catImage": "redstar.png",
	"totalCats": 1,
	"name": "Bursley Hall",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/content/tragedy-bursley",
	"articleSnippet1": "Mar 17, 2016 ... The Regents approved a $4.3 million project to renovate the Bursley Dining Hall \non North Campus this summer. The project aims to remodel ...",
	"articleSnippet2": "Jan 17, 2007 ... Leo Kelly, a 22-year-old psychology major, threw several Molotov cocktail fire \nbombs down the sixth floor of Bursley Residence Hall's Douglas ...",
	"totalMisc": 0,
	"articleTitle2": "Tragedy in Bursley",
	"address": "1931 Duffield St, Ann Arbor, MI 48109",
	"images": [],
	"position": {
		"lat": 42.293697,
		"lng": -83.720933
	},
	"tips": [
		{
			"text": "Food isn't as bad as people say it is, the back room (past the place where you get your food) is usually way less crowded and a better place to chill.",
			"person": "Nick Kortman"
		},
		{
			"text": "Blue Apple (cafe in Bursley lobby) apparently has pretty good sandwiches.",
			"person": "Bob Lesser"
		}
	],
	"bathroomrating": [],
	"categories": {
		"dorm": 1,
		"misc": 1,
		"location": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/bursley.json
// module id = 838
// module chunks = 0